import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import Navbar from "@/components/Navbar";
import AudioPlayerBar from "@/components/AudioPlayerBar";
import Footer from "@/components/Footer";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Catalog from "@/pages/Catalog";
import Pricing from "@/pages/Pricing";
import AIChat from "@/pages/AIChat";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Profile from "@/pages/Profile";
import Community from "@/pages/Community";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import AuthCallback from "@/pages/AuthCallback";

const TOASTER_OPTIONS = {
  style: { background: "#121217", border: "1px solid rgba(255,255,255,0.1)", color: "#F5F5F7", borderRadius: 0 },
};

function App() {
  return (
    <div className="App relative">
      <BrowserRouter>
        <AuthProvider>
          <PlayerProvider>
            <Navbar />
            <main className="relative z-10">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/catalog" element={<Catalog />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/ai" element={<AIChat />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
                <Route path="/community" element={<ProtectedRoute><Community /></ProtectedRoute>} />
                <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/auth/callback" element={<AuthCallback />} />
              </Routes>
            </main>
            <Footer />
            <AudioPlayerBar />
            <Toaster theme="dark" position="top-right" toastOptions={TOASTER_OPTIONS} />
          </PlayerProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
